// utility functions for declaration summary operations

// aggregates documentos from all partidas in a declaration
export const aggregateDocumentosFromPartidas = (declaration, removeDups = false) => {
  if (!declaration.partidas || !Array.isArray(declaration.partidas)) {
    return [];
  }
  
  const allDocumentos = [];
  declaration.partidas.forEach((partida) => {
    if (partida.documentos && Array.isArray(partida.documentos)) {
      partida.documentos.forEach((doc) => {
        if (doc && typeof doc === 'object') {
          allDocumentos.push({ ...doc }); // deep copy
        }
      });
    }
  });
  
  if (removeDups) {
    // remove duplicates based on codigo_documento, tipo, numero, and fecha
    const seen = new Set();
    return allDocumentos.filter((doc) => {
      const key = `${doc.codigo_documento || ''}_${doc.tipo || ''}_${doc.numero || ''}_${doc.fecha || ''}`;
      if (seen.has(key)) {
        return false;
      }
      seen.add(key);
      return true;
    });
  }
  
  return allDocumentos;
};

// creates a signature string from partidas documentos for change detection
export const createPartidasDocumentosSignature = (declaration) => {
  if (!declaration.partidas || !Array.isArray(declaration.partidas)) {
    return '';
  }
  return declaration.partidas
    .map(p => p.documentos ? JSON.stringify(p.documentos) : '[]')
    .join('|');
};

// gets current timestamp in YYYY-MM-DDTHH:MM:SS format
export const getCurrentTimestamp = () => {
  const now = new Date();
  return now.toISOString().slice(0, 19); // YYYY-MM-DDTHH:MM:SS
};

